require("../messages/messageService");
require("../messages/messagesRedirectController");
require("../messages/messagesCreateController");
require("../messages/messagesShowController");
require("../messages/messagesListController");
require("../messages/messagesDetailController");



// WEBPACK FOOTER //
// ./js/messages/messagesLoader.js